<template>
  <content-wrapper :title="labels.LBL_TESTIMONIALS">
    <template #actions>
      <el-button size="small" type="success" @click="handleAdd">
        <i class="el-icon-plus mr-1"></i>
        {{ labels.LBL_ADD }}
      </el-button>
    </template>

    <el-table
      v-loading="loading"
      :data="testimonialList"
      :default-sort="{ prop: 'created_at', order: 'descending' }"
      :empty-text="labels.LBL_NO_DATA"
    >
      <el-table-column label="Photo" width="100">
        <template slot-scope="scope">
          <el-avatar
            :src="scope.row.image_url"
            :size="60"
            shape="circle"
            fit="contain"
          >
            <img
              src="https://cube.elemecdn.com/e/fd/0fc7d20532fdaf769a25683617711png.png"
            />
          </el-avatar>
        </template>
      </el-table-column>

      <el-table-column prop="client_name" :label="labels.LBL_NAME" sortable>
      </el-table-column>

      <el-table-column align="right" width="300">
        <template slot="header" slot-scope="scope">
          <el-row type="flex">
            <el-input
              v-model="search"
              size="mini"
              :placeholder="labels.LBL_TYPE_2_SEARCH"
              class="ml-1"
            />
          </el-row>
        </template>

        <template slot-scope="scope">
          <el-button
            size="mini"
            type="info"
            icon="el-icon-edit"
            circle
            @click="handleEdit(scope.row)"
          >
          </el-button>

          <el-button
            size="mini"
            type="danger"
            icon="el-icon-delete"
            circle
            @click="handleDelete(scope.row)"
          >
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      v-if="pagination"
      :current-page.sync="pagination.current_page"
      :total="pagination.total"
      :page-size="parseInt(pagination.per_page)"
      layout="total, prev, pager, next"
      class="my-2"
      @current-change="handlePageChange"
    >
    </el-pagination>
  </content-wrapper>
</template>

<script>
  import _ from "lodash";
  import { labels } from "@/common";
  import { mapState } from "vuex";
  import ContentWrapper from "@/components/layouts/AdminContentWrapper.vue";

  export default {
    name: "Testimonials",

    components: {
      ContentWrapper,
    },

    data() {
      return {
        labels,

        search: "",
        params: {
          page: 1,
          limit: 4,
        },
      };
    },

    computed: {
      ...mapState({
        loading: (state) => state.isBusy,
        testimonials: (state) => state.testimonial.testimonials,
      }),

      testimonialList() {
        return this.testimonials && this.testimonials.data;
      },

      pagination() {
        return this.testimonials && this.testimonials.meta;
      },
    },

    watch: {
      search: _.debounce(function(nv) {
        this.handleSearch(nv);
      }, 500),

      "params.page": {
        immediate: true,
        handler(nv) {
          if (nv) this.loadCompanies();
        },
      },
    },

    created() {
      this.loadCompanies();
    },

    methods: {
      loadCompanies() {
        this.$store.dispatch("testimonial/getAllTestimonials", this.params);
      },

      handleSearch(search) {
        this.$store.dispatch("testimonial/getAllTestimonials", {
          ...this.params,
          search,
        });
      },

      handlePageChange(val) {
        this.params.page = val;
      },

      handleAdd() {
        this.$router.push({ name: "Add Testimonial" });
      },

      handleEdit({ id }) {
        this.$router.push({
          name: "Edit Testimonial",
          params: { testimonialId: id },
        });
      },

      handleDelete({ id }) {
        this.$confirm(`${labels.CONF_DELETE}?`, labels.LBL_WARN, {
          confirmButtonText: labels.LBL_YES,
          cancelButtonText: labels.CANCEL,
          type: labels.LBL_WARN.toLowerCase(),
        })
          .then(() => {
            this.$store.dispatch("testimonial/deleteTestimonial", id);
          })
          .catch(() => {
            this.$message({
              type: labels.LBL_INFO.toLowerCase(),
              message: labels.CNCL_DELETE,
            });
          });
      },
    },
  };
</script>

<style></style>
